import React, { useContext, useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Route, Switch } from 'react-router-dom';
import './App.css';
import LocalPage from './views/LocalPage/LocalPage';
import StoreLocator from './views/StoreLocator/StoreLocator';

import StateContext from 'common/contexts/state-context';
import MapContext from 'common/contexts/map-context';
import MapService from 'common/services/Map';
import TrackingService from 'common/services/Tracking/Tracking';
import AntiCorruptionService from 'common/services/AntiCorruption';
import FacebookPixel from 'common/components/Tracking/FacebookPIxel/FacebookPixel';
import Header from './widgets/Header';
import Footer from './widgets/Footer';

const App = ({ props }) => {
  /// CORE OF REACT STORELOC APP DONT REMOVE IT ////
  const marshalledState = AntiCorruptionService.marshallState(props);
  const [state, setState] = useState(marshalledState);
  const [cookies] = useCookies();
  TrackingService.init(state, cookies);
  MapService.initMap(state);
  const [map, setMap] = useState(MapService.initialContext);
  useContext(MapContext);
  useContext(StateContext);
  /////////////////////////////////////////////////

  // PERFORMANCE: Defer Critizr/Goodays script until after LCP/user interaction
  useEffect(() => {
    let isMounted = true;

    const loadCritizr = () => {
      if (!isMounted) return;

      // Check if script already exists to prevent duplicates
      if (document.querySelector('script[data-critizr-loaded]')) return;

      try {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.setAttribute('data-critizr-loaded', 'true');
        script.innerHTML = `(function (i, s, o, g, r, a, m) {
          (i[r] = i[r]),
            (a = s.createElement(o)),
            (m = s.getElementsByTagName(o)[0]);
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        })(
          window,
          document,
          "script",
          "https://static.critizr.com/widgets/5b9fd93371411890afdc8c75a8cff387.js",
          "cz"
        );`;
        document.head.appendChild(script);
      } catch (e) {
        // Silently fail - non-critical third-party script
      }
    };

    // Defer loading until idle or user interaction
    if ('requestIdleCallback' in window) {
      const idleId = requestIdleCallback(loadCritizr, { timeout: 3000 });
      return () => {
        isMounted = false;
        cancelIdleCallback(idleId);
      };
    } else {
      // Fallback: load after 2 seconds
      const timer = setTimeout(loadCritizr, 2000);
      return () => {
        isMounted = false;
        clearTimeout(timer);
      };
    }
  }, []);

  return (
    <>
      <Header />
      <div className="appWrapper">
        <StateContext.Provider value={[state, setState]}>
          <MapContext.Provider value={[map, setMap]}>
            <FacebookPixel hardcodedKey={''} />
            <Switch>
              <Route exact path={['/', '/location/:slug']}>
                <StoreLocator />
              </Route>
              <Route path="/:storeId">
                <LocalPage />
              </Route>
            </Switch>
          </MapContext.Provider>
        </StateContext.Provider>
      </div>
      <Footer />
    </>
  );
};

export default App;
